import { useEffect, useState } from "react";

import { VodOutputDTO } from "@kalyzee/kast-web-sdk/http";
import { Loading, MultipleVideoPlayer, Touchable, VideoSourceDated } from "@kalyzee/kast-web-sdk/web-components";
import { usePageContext } from "../../../../components/navigation/PageContext";
import { sdkClient } from "../../../../helpers/sdk";
import { SessionMode } from "../../../../store/session/slices";
import styles from "./vod.module.css";
import { logger } from "../../../../helpers/logger";

export const VodExpertPage = () => {
  const pageContext = usePageContext<SessionMode.MASTER>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [vods, setVods] = useState<VodOutputDTO[]>([]);

  const loadVods = async () => {
    const id = pageContext?.params?.id ?? "";
    if (!id) {
      setError("Internal error");
      return;
    }
    setLoading(true);
    try {
      const baseUrl = sdkClient.getHttpClient().getBaseURL();
      const res = await sdkClient.getHttpClient().client.get(`${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}meeting/${id}/vods`, {});
      logger.log("Vods : ", baseUrl, res);
      if (res.status === 200) {
        setError(undefined);
        setVods(res.data ?? []);
      } else {
        setError("Une erreur est survenue");
      }
    } catch (err) {
      setError("Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadVods();
  }, []);

  if (loading) return <Loading fullscreen message="Chargement en cours..." />;

  const renderContent = () => {
    if (error) {
      return (
        <div>
          Une erreur est survenue
          <Touchable onPress={() => loadVods()}>Réessayer</Touchable>
        </div>
      );
    }

    const data: VideoSourceDated[] = [];
    vods.forEach((v) => {
      const src = v.contentLocations?.length ? v.contentLocations[0]?.videoUrl : undefined;
      const device = (v as any).device;
      const name = device?.name;
      if (!src || !name) return;
      data.push({
        src,
        name,
        startedAt: new Date(v.recordStartedAt),
        endedAt: new Date(v.recordEndedAt),
      });
    });
    return <MultipleVideoPlayer className={styles.vods} data={data} />;
  };
  return <div className={styles.container}>{renderContent()}</div>;
};
